// extracted by mini-css-extract-plugin
module.exports = {"scanner":"TorchButton_scanner__3W4kQ","on":"TorchButton_on__2VrOt","off":"TorchButton_off__1MJa-"};